{
	"app_sidebar": {
		"menu": {
			"theme": "Theme"
		},
		"theme": {
			"dark": "Dark",
			"light": "Light",
			"system": "System"
		},
		"user_menu": {
			"language": "Language",
			"language_no_results": "No languages found",
			"language_search_placeholder": "Search language..."
		}
	},
	"async_pickers": {
		"empty": "No results found",
		"error": "Failed to load options",
		"prompt": "Type to search",
		"selected_count_one": "1 selected",
		"selected_count_other": "{{count}} selected"
	},
	"avatar": {
		"add_photo": "Add photo",
		"change_photo": "Change photo",
		"invalid_type": "Choose a JPEG, PNG, or WebP image.",
		"remove_photo": "Remove photo",
		"too_large": "Choose an image smaller than 5 MB.",
		"upload_error": "Couldn't upload the photo."
	},
	"breadcrumb": {
		"more": "More levels"
	},
	"color_picker": {
		"alpha": "Alpha",
		"alpha_short": "A",
		"clear": "Clear color",
		"eyedropper": "Pick from screen",
		"format": {
			"hex": "HEX",
			"hsl": "HSL",
			"oklch": "OKLCH",
			"rgb": "RGB"
		},
		"hue": "Hue",
		"hue_short": "H",
		"placeholder": "Pick a color",
		"presets": "Presets",
		"validation": {
			"invalid_color": "Please enter a valid OKLCH color"
		}
	},
	"combobox": {
		"clear": "Clear selection",
		"open_list": "Open list"
	},
	"copy_button": {
		"copied": "Copied",
		"copy": "Copy"
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Autosize this column",
			"clear_sort": "Clear sort",
			"hide_column": "Hide column",
			"no_pin": "No pin",
			"pin_column": "Pin column",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"sort_asc": "Sort ascending",
			"sort_desc": "Sort descending",
			"trigger": "Column options for {{column}}"
		},
		"column_settings": {
			"drag_handle": "Reorder column",
			"no_results": "No columns match",
			"pin_column": "Pin {{column}}",
			"pin_left": "Pin left",
			"pin_right": "Pin right",
			"reset": "Reset",
			"search_placeholder": "Search columns...",
			"show_all": "Show all",
			"toggle_visibility": "Toggle {{column}}",
			"trigger": "Columns",
			"unpin": "Unpin"
		},
		"error": "Failed to load data",
		"loading_more": "Loading more...",
		"no_results": "No results",
		"pagination": {
			"go_to_page": "Go to page {{page}}",
			"more_pages": "More pages",
			"next": "Next",
			"previous": "Previous",
			"rows_per_page": "Rows per page"
		},
		"resize_column": "Resize column",
		"select_all": "Select all rows",
		"select_row": "Select row",
		"sort_by": "Sort by {{column}}"
	},
	"date_input": {
		"open_calendar": "Open calendar",
		"validation": {
			"disabled_date": "This date is not available",
			"invalid_date": "Please enter a valid date",
			"max_date": "Date must be on or before {{maxDate}}",
			"min_date": "Date must be on or after {{minDate}}",
			"range": "Date must be between {{minDate}} and {{maxDate}}"
		}
	},
	"date_picker": {
		"cancel": "Cancel",
		"description": "Pick a date from the calendar",
		"presets": {
			"last_30_days": "Last 30 days",
			"last_7_days": "Last 7 days",
			"last_month": "Last month",
			"last_year": "Last year",
			"this_month": "This month",
			"this_week": "This week",
			"this_year": "This year"
		},
		"submit": "Submit",
		"title": "Select date"
	},
	"desktop_only": {
		"description": "The app is currently optimized for desktop. Open the link on your computer to sign in to your account.",
		"title": "Switch to a computer to continue"
	},
	"dialog": {
		"close": "Close"
	},
	"drop_zone": {
		"accepted_formats": "Accepted: {{formats}} · up to {{size}}",
		"choose_files": "Choose files",
		"drag_and_drop_files": "Drag and drop files here",
		"drop_files_here": "Drop files here"
	},
	"filters_sidebar": {
		"applied_filters": "Applied filters",
		"apply_filters": "Apply filters",
		"available_filters": "Available filters",
		"remove_filters_one": "Remove filter",
		"remove_filters_other": "Remove all filters",
		"title": "Filters"
	},
	"http_errors": {
		"admin_already_verified": "This account is already activated: go to sign in.",
		"admin_email_already_exists": "An admin with this email already exists.",
		"admin_forbidden": "You don't have permission to perform this admin action.",
		"admin_invite_token_invalid": "This invitation link has expired or was already used: ask your administrator for a new one.",
		"admin_reset_password_session_missing": "The admin password reset session is missing.",
		"admin_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"admin_session_not_found": "This admin session could not be found.",
		"admin_target_user_not_found": "The selected admin user could not be found.",
		"admin_user_already_deleted": "This admin user has already been deleted.",
		"admin_user_not_found": "Account not found: contact an administrator.",
		"anonymous_sign_in_disabled": "Anonymous sign-in is disabled.",
		"anonymous_user_cannot_change_password": "Anonymous users cannot change their password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Anonymous users can't sign in anonymously again.",
		"api_key_invalid": "The API key is invalid.",
		"apple_android_ott_invalid": "The Apple Android sign-in token is invalid.",
		"apple_android_sign_in_failed": "Apple Android sign-in failed.",
		"apple_mobile_deep_link_not_allowed": "Apple mobile sign-in links are not allowed.",
		"apple_mobile_ott_invalid": "The Apple mobile sign-in token is invalid.",
		"apple_mobile_sign_in_failed": "Apple mobile sign-in failed.",
		"asset_corrupted": "This file could not be processed: upload it again.",
		"asset_mime_type_not_allowed": "This file type is not allowed.",
		"asset_not_found": "This file could not be found.",
		"asset_ownership_error": "You do not have access to this file.",
		"asset_size_too_large": "This file is too large.",
		"asset_storage_missing": "File storage is not available.",
		"auth_credentials_missing": "Sign in before continuing.",
		"auth_csrf_invalid": "Your session security token is invalid: refresh and try again.",
		"auth_email_not_found": "No account with this email address could be found.",
		"auth_jwt_invalid": "Your sign-in session is invalid or has expired: sign in again.",
		"auth_session_issue_failed": "We couldn't complete sign-in: try again.",
		"auth_token_invalid": "Your sign-in session is invalid or has expired: start again.",
		"backoffice_admin_deleted": "This admin account has been deleted.",
		"backoffice_admin_disabled": "This admin account is disabled: contact an administrator.",
		"backoffice_admin_not_found": "This admin account could not be found.",
		"backoffice_auth_credentials_missing": "Sign in as an admin before continuing.",
		"backoffice_auth_token_invalid": "Your sign-in session is invalid or has expired: start again.",
		"backoffice_challenge_not_found": "The admin authentication challenge could not be found.",
		"backoffice_change_password_otp_invalid": "The email code is invalid: try again.",
		"backoffice_change_password_otp_unavailable": "Email codes are not available for changing this admin password.",
		"backoffice_change_password_totp_invalid": "The authenticator code is invalid: try again.",
		"backoffice_csrf_invalid": "Your admin session security token is invalid: refresh and try again.",
		"backoffice_disable_two_factor_method_not_available": "No available method can disable two-factor authentication for this admin account.",
		"backoffice_disable_two_factor_otp_invalid": "The email code is invalid: try again.",
		"backoffice_disable_two_factor_otp_unavailable": "Email codes are not available for disabling two-factor authentication on this admin account.",
		"backoffice_disable_two_factor_passkey_invalid": "Passkey verification failed: try again.",
		"backoffice_disable_two_factor_recovery_code_invalid": "The recovery code is invalid: try again.",
		"backoffice_disable_two_factor_totp_invalid": "The authenticator code is invalid: try again.",
		"backoffice_email_already_in_use": "An admin account with this email already exists.",
		"backoffice_email_change_token_invalid": "The admin email change session is invalid or has expired.",
		"backoffice_email_otp_token_invalid": "Your verification session has expired: request a new code.",
		"backoffice_failed_to_verify_registration": "The admin passkey registration could not be verified.",
		"backoffice_invalid_code": "The code is invalid.",
		"backoffice_invalid_email_or_password": "The email or password is invalid.",
		"backoffice_invalid_password": "The password is invalid.",
		"backoffice_invite_invalid": "This admin invitation is invalid or has expired.",
		"backoffice_jwt_invalid": "Your admin session is invalid or has expired: sign in again.",
		"backoffice_mfa_challenge_invalid": "Your verification session has expired: sign in again.",
		"backoffice_mfa_challenge_required_for_change_password": "Verify your identity before changing this admin password.",
		"backoffice_mfa_device_limit_reached": "This admin account has reached the two-factor device limit.",
		"backoffice_mfa_email_otp_not_available": "Email verification codes aren't available for this account.",
		"backoffice_mfa_enrollment_expired": "Two-factor setup has expired: start again.",
		"backoffice_mfa_invalid_backup_code": "The backup code is invalid: try again.",
		"backoffice_mfa_invalid_email_otp": "The email code is invalid: try again.",
		"backoffice_mfa_invalid_passkey": "Passkey verification failed: try again.",
		"backoffice_mfa_invalid_totp_code": "The authenticator code is invalid: try again.",
		"backoffice_mfa_not_enabled": "Two-factor authentication is not enabled for this admin account.",
		"backoffice_mfa_passkey_not_available": "Passkey verification is not available for this admin account.",
		"backoffice_new_email_same_as_current": "The new admin email matches the current email.",
		"backoffice_no_change_password_method_available": "No available method can change this admin password.",
		"backoffice_passkey_authentication_failed": "Admin passkey authentication failed.",
		"backoffice_passkey_limit_reached": "This admin account has reached the passkey limit.",
		"backoffice_passkey_not_found": "This admin passkey could not be found.",
		"backoffice_reset_password_session_missing": "The admin password reset session is missing.",
		"backoffice_reset_password_token_invalid": "The admin password reset token is invalid or expired.",
		"backoffice_self_edit_forbidden": "You cannot edit your own admin account here.",
		"backoffice_session_expired": "Your admin session has expired: sign in again.",
		"backoffice_session_invalid": "Your admin session is no longer valid: sign in again.",
		"backoffice_session_issue_failed": "We couldn't complete sign-in: try again.",
		"backoffice_social_not_registered": "No admin account is registered for this social sign-in.",
		"backoffice_totp_authenticator_not_found": "This admin authenticator could not be found.",
		"backoffice_you_are_not_allowed_to_register_this_passkey": "You are not allowed to register this admin passkey.",
		"backup_codes_not_enabled": "Backup codes are not enabled for this account.",
		"blacklisted_email_domain": "This email domain is not allowed.",
		"broadcast_recipients_not_found": "None of the selected recipients could be found.",
		"challenge_not_found": "The authentication challenge could not be found.",
		"change_password_otp_invalid": "The email code is invalid: try again.",
		"change_password_otp_unavailable": "Email codes are not available for changing this password.",
		"change_password_totp_invalid": "The authenticator code is invalid: try again.",
		"conversation_not_found": "This conversation could not be found.",
		"credential_account_not_found": "The credential account could not be found.",
		"csrf_token_mismatch": "Your session security token is stale: refresh and try again.",
		"default": "Oops! Something went wrong.",
		"delete_anonymous_user_disabled": "Anonymous user deletion is disabled.",
		"disable_two_factor_method_not_available": "No available method can disable two-factor authentication for this account.",
		"disable_two_factor_otp_invalid": "The email code is invalid: try again.",
		"disable_two_factor_otp_unavailable": "Email codes are not available for disabling two-factor authentication on this account.",
		"disable_two_factor_passkey_invalid": "Passkey verification failed: try again.",
		"disable_two_factor_recovery_code_invalid": "The recovery code is invalid: try again.",
		"disable_two_factor_totp_invalid": "The authenticator code is invalid: try again.",
		"email_already_in_use": "An account with this email already exists.",
		"email_already_verified": "This email address is already verified.",
		"email_can_not_be_updated": "This email address can't be updated.",
		"email_change_token_invalid": "The email change session is invalid or has expired.",
		"email_domain_not_allowed": "This email domain is not allowed for admin accounts.",
		"email_mismatch": "The email address does not match.",
		"email_not_verified": "This email address is not verified.",
		"email_otp_token_invalid": "Your verification session has expired: request a new code.",
		"email_password_disabled": "Email and password sign-in is disabled.",
		"email_password_sign_up_disabled": "Email and password sign-up is disabled.",
		"expires_in_is_too_large": "The expiration duration is too long.",
		"expires_in_is_too_small": "The expiration duration is too short.",
		"export_not_found": "This export could not be found.",
		"export_too_large_for_sync": "This export is too large for direct download: use auto or email when ready.",
		"failed_to_create_session": "The session could not be created.",
		"failed_to_create_user": "The user could not be created.",
		"failed_to_delete_anonymous_user": "The anonymous user could not be deleted.",
		"failed_to_get_user_info": "The user information could not be loaded.",
		"failed_to_update_passkey": "The passkey could not be updated.",
		"failed_to_verify_registration": "The registration could not be verified.",
		"forbidden": "You don't have permission to perform this action.",
		"id_token_not_supported": "This identity token is not supported.",
		"idempotency_in_flight": "The same request is still being processed: wait a moment and try again.",
		"idempotency_key_required": "The request was sent without its idempotency key: reload the page and try again.",
		"idempotency_key_reused": "That idempotency key was already used for a different request: start the operation again.",
		"invalid_backup_code": "The backup code is invalid.",
		"invalid_code": "The code is invalid.",
		"invalid_delete_account_otp": "The account deletion code is invalid.",
		"invalid_email": "The email address is invalid.",
		"invalid_email_or_password": "The email or password is invalid.",
		"invalid_metadata_type": "The metadata type is invalid.",
		"invalid_name_length": "The name length is invalid.",
		"invalid_otp": "The one-time password is invalid.",
		"invalid_password": "The password is invalid.",
		"invalid_prefix_length": "The prefix length is invalid.",
		"invalid_remaining": "The remaining value is invalid.",
		"invalid_token": "The token is invalid or expired.",
		"invalid_two_factor_cookie": "The two-factor authentication cookie is invalid.",
		"key_not_found": "The API key could not be found.",
		"last_social_account_without_email": "Add an email address before unlinking your last social account.",
		"llm_not_configured": "The AI service is not available right now.",
		"llm_unavailable": "The AI service is temporarily unavailable: try again later.",
		"maintenance_mode": "The service is temporarily in maintenance mode.",
		"message_not_editable": "This message can no longer be edited.",
		"message_not_found": "This message could not be found.",
		"metadata_disabled": "Metadata is disabled for this API key.",
		"name_required": "A name is required.",
		"new_email_same_as_current": "The new email matches the current email.",
		"no_change_password_method_available": "No available method can change this password.",
		"no_values_to_update": "There are no values to update.",
		"node_purged": "This item is being permanently deleted and can no longer be restored.",
		"oidc_callback_exchange_failed": "Sign-in could not be completed: try again.",
		"oidc_callback_state_invalid": "This sign-in link is no longer valid: start again from the sign-in page.",
		"organization_login_unavailable": "This organization is not available for sign-in: check the name and try again.",
		"organization_slug_taken": "That address is already in use by another organization.",
		"otp_expired": "The one-time password has expired.",
		"otp_has_expired": "The one-time password has expired: request a new code.",
		"otp_issuance_throttled": "Too many code requests: wait before requesting a new one.",
		"otp_not_enabled": "One-time passwords are not enabled.",
		"password_too_long": "The password is too long.",
		"password_too_short": "The password is too short.",
		"permission_denied": "Your account is signed in, but it doesn't have the permissions required to view this page.",
		"provider_not_found": "The authentication provider could not be found.",
		"purge_not_allowed": "Only the owner of what you want to destroy can delete it permanently. Ask them, or restore it instead.",
		"reset_password_disabled": "Password reset is disabled.",
		"reset_password_session_missing": "The password reset session is missing.",
		"reset_password_token_invalid": "The password reset token is invalid or expired.",
		"resolve_user_required": "A user must be resolved before continuing.",
		"resolved_user_invalid": "The resolved user is invalid.",
		"server_only_property": "This property can only be changed by the server.",
		"session_expired": "Your session has expired: sign in again.",
		"session_invalid": "Your session is no longer valid: sign in again.",
		"session_not_found": "This session could not be found.",
		"session_not_fresh": "Please reauthenticate before continuing.",
		"session_required": "A valid session is required.",
		"sign_up_session_missing": "The sign-up session is missing.",
		"too_many_attempts": "Too many attempts: try again later.",
		"too_many_attempts_request_new_code": "Too many attempts: request a new code.",
		"two_factor_not_enabled": "Two-factor authentication is not enabled.",
		"unable_to_create_session": "A new session could not be created.",
		"unauthorized": "You're not signed in: log in to continue.",
		"unauthorized_session": "This session is not authorized.",
		"user_already_exists_use_another_email": "A user with this email already exists: use another email address.",
		"user_already_has_provider_linked": "This user already has that provider linked.",
		"user_banned": "This user account has been banned.",
		"user_deleted": "This user account has been deleted.",
		"user_email_not_found": "No user with this email address could be found.",
		"user_is_not_anonymous": "This user is not anonymous.",
		"user_not_found": "This user could not be found.",
		"validation_error": "Some of the information you entered is invalid.",
		"verification_email_not_enabled": "Verification emails are not enabled.",
		"verify_email_session_missing": "The email verification session is missing.",
		"verify_email_token_invalid": "The email verification token is invalid or expired.",
		"you_are_not_allowed_to_register_this_passkey": "You're not allowed to register this passkey."
	},
	"infinite_virtual_list": {
		"empty": "No results",
		"error": "Failed to load data"
	},
	"inline_filter_date": {
		"from": "From {{date}}",
		"to": "Until {{date}}"
	},
	"inline_filters": {
		"clear": "Clear filter",
		"clear_all": "Clear all",
		"confirm": "Confirm",
		"scroll_next": "Scroll filters right",
		"scroll_previous": "Scroll filters left"
	},
	"input_bytes": {
		"unit": "Unit"
	},
	"input_currency": {
		"empty": "No currency found",
		"search": "Search currency...",
		"select_currency": "Select currency",
		"validation": {
			"invalid_amount": "Please enter a valid amount"
		}
	},
	"input_password": {
		"hide": "Hide password",
		"show": "Show password"
	},
	"input_phone": {
		"empty": "No country found",
		"search": "Search country...",
		"select_country": "Select country",
		"validation": {
			"invalid_phone_number": "Please enter a valid phone number"
		}
	},
	"list_input_search": {
		"clear": "Clear search"
	},
	"pagination": {
		"more_pages": "More pages",
		"next_page": "Go to next page",
		"previous_page": "Go to previous page"
	},
	"passkey": {
		"already_registered": "There's already a passkey for this account on this device.",
		"cancelled": "No passkey was used. Try again or sign in with another method.",
		"not_supported": "This device can't create a passkey with the requested settings.",
		"security": "Your browser blocked the passkey request for this site. This usually means the site address doesn't match the server's passkey configuration."
	},
	"password_requirements": {
		"met": "met",
		"unmet": "not met"
	},
	"query_breadcrumbs": {
		"error": "Error",
		"no_data": "Detail"
	},
	"quota_field": {
		"required": "A quota is required.",
		"unlimited": "No limit"
	},
	"refresh_button": {
		"refresh": "Refresh",
		"updated_at": "Last updated: {{time}}"
	},
	"rich_text_editor": {
		"blocks": {
			"blockquote": "Blockquote",
			"bulleted_list": "Bulleted list",
			"code_block": "Code block",
			"h1": "Heading 1",
			"h2": "Heading 2",
			"h3": "Heading 3",
			"numbered_list": "Numbered list"
		},
		"code_block_languages": {
			"bash": "Bash",
			"css": "CSS",
			"html": "HTML",
			"js": "JavaScript",
			"json": "JSON",
			"md": "Markdown",
			"plain": "Plain text",
			"python": "Python",
			"ts": "TypeScript"
		},
		"editor_label": "Rich text editor",
		"mention": {
			"empty": "No matches"
		},
		"slash": {
			"empty": "No commands match"
		},
		"toolbar": {
			"bold": "Bold",
			"code": "Inline code",
			"italic": "Italic",
			"spoiler": "Spoiler",
			"strikethrough": "Strikethrough",
			"underline": "Underline"
		}
	},
	"sheet": {
		"close": "Close"
	},
	"sidebar": {
		"toggle": "Toggle sidebar"
	},
	"two_factor": {
		"backup_description": "Enter one of your single-use backup codes.",
		"backup_label": "Backup code",
		"verify": "Verify"
	},
	"two_factor_device_picker": {
		"device_label": "Authenticator device",
		"device_unnamed": "Unnamed device"
	},
	"validation": {
		"otp_length": "Code must be 6 digits."
	}
}
